import Bowser from 'bowser'

interface DeviceInfo {
  platformType: string
  osName: string
  browserName: string
}

export const useDevice = (): DeviceInfo | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }

  const browser = Bowser.getParser(window.navigator.userAgent)

  const platformType = browser.getPlatformType()

  const osName = browser.getOSName()

  const browserName = browser.getBrowserName()

  return {
    platformType,
    osName,
    browserName,
  }
}
